import { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Categories from "./components/Categories";
import DailyUpdates from "./components/DailyUpdates";
import Featured from "./components/Featured";
import Ongoing from "./components/Ongoing";
import Finished from "./components/Finished";
import FollowGuide from "./components/FollowGuide";
import FAQ from "./components/FAQ";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

const featureTabs = ["全部", "少女漫画", "甜宠漫画", "萌系漫画", "治愈漫画"];

export default function Home() {
  const [search, setSearch] = useState("");
  const [tab, setTab] = useState("全部");

  const handleCategory = (name: string) => {
    if (featureTabs.includes(name)) {
      setTab(name);
      setSearch("");
    } else {
      setTab("全部");
      setSearch(name);
    }
  };

  return (
    <main>
      <Navbar />
      <Hero onSearch={(kw) => {
        setSearch(kw);
        setTab("全部");
      }} />
      <Categories onSelect={handleCategory} />
      <DailyUpdates />
      <Featured
        search={search}
        onClearSearch={() => setSearch("")}
        tab={tab}
        onTabChange={setTab}
      />
      <Ongoing />
      <Finished />
      <FollowGuide />
      <FAQ />
      <Newsletter />
      <Footer />
      <BackToTop />
    </main>
  );
}